<template>
  <div class="hl-overlay" @click.self="!persistent && $emit('close')">
    <div class="hl-confirm-card">
      <button
        type="button"
        class="hl-close hl-close--outline"
        @click="$emit('close')"
      >
        &times;
      </button>

      <h3 class="hl-confirm-title">{{ title }}</h3>
      <slot />

      <div class="hl-confirm-actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/event-highlights.css";

export default {
  name: "HighlightDialog",
  props: {
    title: { type: String, required: true },

    persistent: { type: Boolean, default: false },
  },
  emits: ["close"],
};
</script>
